module.exports = __webpack_public_path__ + "img/header_image.da065367.png";